<template>
  <div class="article">
    <div class="title">迪拜皇家拍卖公司董事局主席洪子晴爵士 拿督斯里与香港艺术家林文杰教授携手艺术赋能慈善公益</div>
    <div class="info">作者：晴天集团    发布于：2025-07-24 00:09</div>
    <p>迪拜皇家拍卖公司董事局主席洪子晴爵士（HCC ROYAL AUCTION - FZCO）拍卖公司于2024年成立，积极推动中国与阿联酋贸易文化交流，2025年在迪拜举办第一届中国艺术品拍卖会，呈献古代和近现代中国书画、中国瓷器与工艺品、青铜器、茶道用具、文房四宝、珠宝及钟表等，预期在中国香港、巴黎、上海及北京进行预展。</p>
    <p>2025年6月林文杰教授（Professor Dominic Lam）正式受聘为HCC ROYAL AUCTION - FZCO迪拜皇家拍卖公司名誉顾问。</p>
    <p>香港艺术家林文杰教授智商200的他，读数理出身。十六岁入大学，二十四岁已成为哈佛物理系助理教授，后因发明预防「再发性白内障」的药物将公司上市。他1988年开始研究口服疫苗，2000年成功用于猪身上治疗肠胃炎，被《时代》杂志选为二十一世纪十大发明之一。热衷慈善事业的他开始回报桑梓，与「奥比斯国际眼科飞行医院」创办人首次访问内地，将服务带入内地；1999年他回到香港创办「世界眼科组织」，还在内地推行防盲治盲工作；就连如今的香港科学园中都与他有莫大联系。潮州出生、香港长大、美国求学……正如那个时代其他回流人士一样，他还促进了两国的沟通。讲起过去的经历，林文杰聊得起劲，随手拿来几个照片，都是与元首的合照，他说，「很多人都说我是一个桥梁。」除了科学之外，林文杰的绘画、文学造诣深厚，甚至走上科学之路也源于「如果不能当视觉艺术家，就当视觉科学家」的初心，而成为著名的眼科医生。他还喜欢作画，一幅以展现奔流水势的「九天银河」在北京钓鱼台国宾馆陈列；他翻译诗歌，并为诗词作画，将诗情融入画意；他是雕塑的一把好手，他创作的和平鸽雕塑曾在巴黎罗浮宫展览；他还涉猎文学领域，他与前美国驻联合国大使Jeffrey Busch的著作《Accidental Diplomacy》（《意外的外交》）刚刚获得2022年美国作家最佳著作奖。科学家、画家、诗人……跨度之大，他以个人天赋与奋斗，颠覆了「有所长必有所弱」的大众认知。而无论生物科技还是文化艺术，在林文杰看来，其精髓在于「创」。</p>
    <p>在学界，林文杰教授——他六年内取得数学学士、理论物理学硕士及医学生物物理学博士学位。年仅廿二岁便进入美国哈佛医学院跟随诺贝尔医学奖得主 Wiesel 与 Hubel 教授从事眼科、脑科与生物科技研究。林文杰教授是国际知名艺术家及『折光画』(Chromoskedasic Painting; 或称纳米艺术， NanoArt) 之发明者 (刊登于 1991 年 11 月美国科学家杂志，Scientific American)。 林教授曾任美国总统艺术人文委员会委员。 1999 年林教授被中国美术家协会、 中央美术学院及北京故宫选为『二十世纪中国画坛上最具代表性与影响力的 99 位中国艺术家』之一。</p>
    <p>在慈善界，林文杰教授——林教授于1982年与 David Patron成立Project Orbis国际奥比斯非牟利组织，并进行全球唯一慈善飞机医院DC-8的首次处女航，由美国直飞中国为祖国人民开始救盲工作及带来重要的眼科护利 !林教授义务为失明者重见光明而努力不懈的人。 1982 年起协助『奥比斯国际眼科飞行医院』首次访问 中国，又于 1999 年创办『世界眼科组织』 (WEO)，主旨在中国贫穷地区推行防盲治盲工作。江泽民主席为他提字；胡锦涛总书记为他提字、美国四任总统为他提字。</p>
    <p>林文杰教授深深体会到科学及艺术的“黏着”美，也由于他说我自幼热爱中国书画艺术，结识张大千、赵少昂、杨善琛、关山月、周士心等着名画家，使得他能在科学探索中，体验出艺术之美，又在艺术创作中，得到科学之真的启发。林文杰在视觉神经学的研究中，开创“纳米艺术"(NanoArt)的先河，他的许多画作被称之为“折光画”(Chromoskedasic Painting)也成为新艺术的媒介。经过长期的实践，林文杰以“折光画”为主题，把视觉神经研究及视觉艺术创作结合，在世界各地举办画展，取得良好回响，也促使他成为当代最具影响力的中国艺术家之一。</p>
    <p>林文杰教授的作品在佳士得拍卖行（Christie's Auction）拍出超过港币两千万佳绩，所得全数捐给世界眼科组织。佳士得拍卖行（Christie's Auction）2015年在香港为林文杰教授举办了一场画展，其中两幅画作最终售价超过三百万港币（约四十万美元），四幅拍卖作品和三十幅单独出售画作共获得超过两千万港币佳绩。林文杰教授「羊羊喜庆│天地人和」画展展示了他多样的创作风格，既有传统的中国字画、色彩鲜艷的抽象油画，也有多种风格与介质结合的独特画作，例如名为《伴》的画作上，两匹水墨骏马奔跑在璀璨银河之中。</p>
    <p>今次HCC ROYAL AUCTION - FZCO迪拜皇家拍卖公司董事局主席洪子晴爵士携手香港艺术家林文杰教授在迪拜举办拍卖会，知名艺术家林教授决定拿出六幅精心创作的作品进行公开拍卖，并且当场郑重承诺，将拍卖所得款项平分，分别捐赠给世界眼科组织与洪子晴慈善基金会，以实际行动汇聚爱心，推动公益事业前行，洪子晴爵士携手香港艺术家林文杰教授艺术赋能公益助力眼科与慈善事业。这不仅是对艺术价值的肯定，更是对公益善举的由衷赞许。是艺术与公益的深度融合。林教授用作品搭建起爱心桥梁，让艺术创作的意义超越审美本身，延伸至社会公益服务。他表示，未来会持续关注公益，以艺术为笔、以爱心为墨，书写更多温暖故事，也呼吁更多人关注公益、参与公益，凝聚微小善意，成就社会大爱，共同为需要帮助的群体撑起一片更晴朗的天空。</p>
    <p><strong>洪子晴慈善基金会：慈善之路，爱满人间</strong></p>
    <p><strong>创立基金会，筑牢慈善根基</strong><br>
    2008 年 8 月，汶川大地震的阴霾尚未消散，大地满目疮痍，受灾群众亟待援助。洪子晴博士怀着深切的悲悯之心，以个人名义毅然捐献 100 万元，创立了 “洪子晴慈善基金会”。不仅如此，洪子晴爵士还许下庄重承诺，将自己公司每年盈利的 10% 持续注入基金会，为慈善事业的长远发展提供了稳固的资金保障，宛如为一艘在慈善海洋中破浪前行的巨轮奠定了坚实的龙骨。</p>
    <p><strong>教育扶贫，点亮希望灯塔</strong><br>
      教育，是斩断贫困枷锁的利刃，是开启未来之门的钥匙。洪子晴爵士深刻洞察这一点，基金会在其带领下，积极投身于贫困山区的教育援建工作。从东南亚到非洲，跨越千山万水，基金会援建的学校如雨后春笋般涌现。这些学校，成为了当地孩子梦想起航的港湾。</p>
    <p>在柬埔寨，乡村部落的孤儿们生活困苦，教育资源极度匮乏。洪子晴慈善基金会挺身而出，助力他们入读当地大学。2025年，受助的孤儿成功踏入大学校园，成为家族中第一代接受高等教育的幸运儿。他们眼中闪烁的希望之光，正是洪子晴爵士慈善行动的最美注脚。此外，基金会还设立奖学金，激励学子奋发图强；开展教师培训项目，提升教育质量，为贫困地区的教育事业构建起全方位的支持体系。</p>
    <p><strong>医疗民生，守护幸福底线</strong><br>
      医疗条件的改善，是关乎民生福祉的大事。洪子晴慈善基金会积极为农村地区建设医疗诊所，配备基本医疗设备，让村民们在家门口就能享受到便捷的医疗服务，极大缓解了乡村地区看病难的问题。</p>
    <p>在民生帮扶方面，基金会对贫困家庭关爱有加。助养孤儿，给予他们生活的保障与心灵的慰藉；定期探访老人，为他们送去温暖与关怀，让他们感受到社会的尊重与关爱；在缺水地区助建水窖，解决了当地居民的用水难题，滋润了干涸的生活。</p>
    <p><strong>多元公益，汇聚爱心洪流</strong><br>
      除了教育与医疗民生领域，洪子晴爵士和洪子晴爵士的基金会还活跃在多元的公益活动中。基金会踊跃参与赞助不同慈善机构的活动，招募义工，凝聚起社会各界的爱心力量，让更多人投身到公益事业中来。</p>
    <p>2009 年 7 月 8 日，洪子晴慈善基金会推出慈善新碟《walk with love》与爱同行，发布会在香港四季酒店海景厅盛大举行。这张饱含爱心的唱片，其收益在不扣除任何制作成本的情况下，全部平均捐赠予香港红十字会、世界宣明会、无国界医生、乐施会四大机构，为慈善事业注入了一股强大的暖流。</p>
    <p><strong>荣誉加身，不忘初心前行</strong><br>
      多年来，洪子晴爵士的慈善善举赢得了社会各界的高度赞誉。2012 年，洪子晴爵士荣获 “品牌中国慈善年度人物” 大奖；2023 年，新加坡现任总统哈莉玛・雅各布女士亲自为洪子晴爵士颁授艺术与慈善大奖；2022 年，洪子晴爵士又获颁 “杰出港人 2022” 之慈善人物大奖。这些荣誉，是对洪子晴爵士慈善成就的肯定，更是洪子晴爵士继续前行的动力源泉</p>
    <p>面对诸多荣誉，洪子晴爵士始终保持谦逊与初心。洪子晴爵士常说：“我觉得成功要有一颗感恩的心，大爱之心，无私奉献的善心，也希望将这上帝的幸运恩赐带给更多不幸的人，帮助更多的人。” 洪子晴爵士用自己的实际行动，生动诠释着慈善的真谛，引领着更多人踏上爱心之路。在未来的日子里，将继续在慈善之路上阔步前行，用爱编织更加美好的世界，让温暖与希望的阳光照亮每一个角落。</p>
    <img src="@/assets/img/article/0724/1.webp" alt="">
    <p class="img-alt-content">洪子晴爵士拿督斯里颁受HCC ROYAL AUCTION - FZCO迪拜皇家拍卖公司名誉顾问给林文杰教授</p>
    <img src="@/assets/img/article/0724/2.webp" alt="">
    <img src="@/assets/img/article/0724/3.webp" alt="">
    <img src="@/assets/img/article/0724/4.webp" alt="">
    <img src="@/assets/img/article/0724/5.webp" alt="">
    <img src="@/assets/img/article/0724/6.webp" alt="">
    <img src="@/assets/img/article/0724/7.webp" alt="">
    <img src="@/assets/img/article/0724/8.webp" alt="">
    <img src="@/assets/img/article/0724/9.webp" alt="">
    <img src="@/assets/img/article/0724/10.webp" alt="">
    <img src="@/assets/img/article/0724/11.webp" alt="">
    <img src="@/assets/img/article/0724/12.webp" alt="">
    <img src="@/assets/img/article/0724/13.webp" alt="">
    <img src="@/assets/img/article/0724/14.webp" alt="">
    <img src="@/assets/img/article/0724/15.webp" alt="">
    <img src="@/assets/img/article/0724/16.webp" alt="">
    <img src="@/assets/img/article/0724/17.webp" alt="">
    <img src="@/assets/img/article/0724/18.webp" alt="">
    <img src="@/assets/img/article/0724/19.webp" alt="">
    <p class="img-alt-content">林文杰教授作品---荣获伦敦奥运的唯一一个奥林匹克艺术金牌</p>

  </div>
</template>

<script>
  export default {
    name: '1',
    components: {},
    data() {
      return {}
    }
  }
</script>

<style scoped lang="scss">
  .article{
    width: 70%;
    margin: 20px auto;
    font-family: $font-family;
    .title{
      font-size: 1.4rem;
      font-weight: bold;
      line-height: 50px;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: $content-font-size;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 60%;
      margin-left: 20%;
    }

    .img-alt{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      padding-top: 10px;
      color: #2f2e2e;
      font-size: 0.9rem;
    }

    .img-alt-content{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      padding-top: 5px;
      padding-bottom: 15px;
      color: #2f2e2e;
      font-size: 0.9rem;
    }
  }

  @media (max-width: 768px) {
    .article{
      width: 90%;
      margin: 20px auto;
      .title{
        padding-top: 10px;
        padding-bottom: 8px;
        font-size: 1.1rem;
        font-weight: bold;
        line-height: 1.3;
        text-align: center;
      }

      .info{
        height: 28px;
        line-height: 28px;
        border-bottom: 1px #e8e8e8 solid;
        margin: 0;
        text-align: center;
        font-size: 0.8rem;
      }

      p{
        font-size: $phone-content-font-size;
        color: #000000;
        line-height: 2;
        margin: 20px 0;
      }

      img{
        width: 80%;
        margin-left: 10%;
      }

      .img-alt{
        text-align: center;
        line-height: 1;
        margin: 6px 0;
        color: #2f2e2e;
        padding-top: 5px;
        font-size: 0.8rem;
      }
      .img-alt-content{
        text-align: center;
        line-height: 1;
        margin: 6px 0;
        padding-top: 5px;
        padding-bottom: 15px;
        color: #2f2e2e;
        font-size: 0.8rem;
      }
    }
  }

  @media (max-width: 480px) {
    .article{
      width: 100vw;
      padding: 0 10px;
      box-sizing: border-box;
      margin: 20px auto;
      .title{
        padding-top: 10px;
        padding-bottom: 8px;
        font-size: 1.1rem;
        font-weight: bold;
        line-height: 1.3;
        text-align: center;
      }

      .info{
        height: 28px;
        line-height: 28px;
        border-bottom: 1px #e8e8e8 solid;
        margin: 0;
        text-align: center;
        font-size: 0.8rem;
      }

      p{
        font-size: $phone-content-font-size;
        color: #000000;
        line-height: 2;
        margin: 20px 0;
      }

      img{
        width: 100%;
        margin: 0;
      }

      .img-alt{
        text-align: center;
        line-height: 1;
        font-size: 0.7rem;
        margin: 6px 0;
        color: #666;
      }
    }
  }
</style>
